import { Roles } from 'src/shared/enums';
import { AuthGuard } from '../shared/auth/guards/auth.guard';
import { RoleGuard } from '../shared/auth/guards/role.guard';

export const dwrsPaths = {
	default: '',
	root: 'daily-work-reports',
	list: 'list',
	detail: ':id',
	calendar: 'calendar',
};

export const dwrsFragments = {
	default: [dwrsPaths.default],
	root: [dwrsPaths.default, dwrsPaths.root],
	calendar: [dwrsPaths.default, dwrsPaths.root, dwrsPaths.calendar],
	list: [dwrsPaths.default, dwrsPaths.root, dwrsPaths.list],
	detail: (id: number) => [dwrsPaths.default, dwrsPaths.root, id],
};

export const dwrsDefaultAuthRoles = [
	Roles.Admin,
	Roles.FieldDirector,
	Roles.FieldManager,
	Roles.FieldSupport,
	Roles.HR,
];

export const dwrsDefaultAuth = {
	canActivate: [AuthGuard, RoleGuard],
	data: { roles: dwrsDefaultAuthRoles },
};
